import { render } from "./VariantBasicInfo.vue?vue&type=template&id=a047e304"
import script from "./VariantBasicInfo.vue?vue&type=script&lang=js"
export * from "./VariantBasicInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/grosscol/workspace/bravue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__